import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Circle, Square, RectangleHorizontal } from 'lucide-react';

const badgeTypes = [
  {
    id: 'round-44',
    type: 'round',
    label: '44mm Round',
    icon: Circle,
    designArea: 54,
    badgeSize: 44,
    description: 'Design: 54mm (includes 10mm bleed)',
    color: 'from-primary to-primary-glow'
  },
  {
    id: 'round-58',
    type: 'round',
    label: '58mm Round',
    icon: Circle,
    designArea: 70,
    badgeSize: 58,
    description: 'Cutting: 70mm',
    color: 'from-secondary to-purple-400'
  },
  {
    id: 'square-50',
    type: 'square',
    label: '50x50mm Square',
    icon: Square,
    designArea: 62,
    badgeSize: 50,
    description: 'Design: 62x62mm',
    color: 'from-accent to-yellow-400'
  },
  {
    id: 'rect-80-53',
    type: 'rectangle',
    label: '80x53mm Rectangle',
    icon: RectangleHorizontal,
    designWidth: 95,
    designHeight: 70,
    badgeWidth: 80,
    badgeHeight: 53,
    description: 'Design: 95x70mm',
    color: 'from-success to-green-400'
  },
  {
    id: 'rect-90-65',
    type: 'rectangle',
    label: '90x65mm Rectangle',
    icon: RectangleHorizontal,
    designWidth: 109,
    designHeight: 85,
    badgeWidth: 90,
    badgeHeight: 65,
    description: 'Design: 109x85mm',
    color: 'from-blue-500 to-blue-400'
  }
];

export default function BadgeSizeSelector({ selectedBadge, onSelectBadge, orientation, onOrientationChange }) {
  return (
    <div className="space-y-4">
      <div className="grid gap-3">
        {badgeTypes.map((badge) => {
          const Icon = badge.icon;
          const isSelected = selectedBadge?.id === badge.id;
          
          return (
            <button
              key={badge.id}
              onClick={() => onSelectBadge(badge)}
              className={`w-full p-4 rounded-2xl border-2 transition-all duration-300 text-left group hover:scale-102 ${
                isSelected
                  ? 'border-primary bg-primary/5 shadow-playful'
                  : 'border-border hover:border-primary/50 bg-card'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${badge.color} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="font-semibold text-sm">{badge.label}</h4>
                    {isSelected && (
                      <Badge className="h-5 text-xs rounded-full bg-gradient-to-r from-primary to-secondary text-primary-foreground">
                        Selected
                      </Badge>
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground">{badge.description}</p>
                </div>
              </div>
            </button>
          );
        })}
      </div>

      {selectedBadge?.type === 'rectangle' && (
        <div className="pt-4 border-t border-border">
          <label className="text-sm font-medium mb-2 block">Orientation</label>
          <div className="grid grid-cols-2 gap-2">
            <Button
              variant={orientation === 'portrait' ? 'default' : 'outline'}
              onClick={() => onOrientationChange('portrait')}
              className="rounded-xl"
              size="sm"
            >
              Portrait
            </Button>
            <Button
              variant={orientation === 'landscape' ? 'default' : 'outline'}
              onClick={() => onOrientationChange('landscape')}
              className="rounded-xl"
              size="sm"
            >
              Landscape
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
